import config from 'config';

import { useMembership } from '~/techstyle-shared/react-accounts';
import { useNav } from '~/techstyle-shared/react-navigation';

import useSecondarySite from './useSecondarySite';

export default function useAccountLinks(options = {}) {
  const { isNavToolbar = false } = options;
  const { isVip } = useMembership();
  const secondarySite = useSecondarySite();

  const filter = () => {
    return ({ itemKey }) => {
      if ((isNavToolbar || !isVip) && itemKey === 'my_account_my_vip') {
        return false;
      }
      return true;
    };
  };

  const navConfig = secondarySite
    ? config.get('public.secondarySite.outlet.navigation.myAccountNav')
    : config.get('public.brand.navigation.myAccountNav');

  return useNav(navConfig, {
    filter,
  });
}
